<div class="provider-filter">
  <label class="text-sm text-gray-300 mb-1 block" for="provider-filter">
    {{ 'project.steps.providerResults.subcriteriaAttributes.providerFilter' | transloco }}
  </label>
  <p-multiSelect
    inputId="provider-filter"
    [options]="providerOptions()"
    [ngModel]="selectedProviderIds()"
    (onChange)="onSelectionChange($event.value)"
    optionLabel="label"
    optionValue="value"
    [placeholder]="
      'project.steps.providerResults.subcriteriaAttributes.providerFilterPlaceholder' | transloco
    "
    [showToggleAll]="true"
    [filter]="true"
    class="w-full"
  >
    <ng-template #selecteditems let-selectedOptions>
      @if (selectedOptions?.length > 0) {
        {{ selectedOptions.length }} {{ 'multiselect.selected' | transloco }}
      }
    </ng-template>
  </p-multiSelect>
</div>
